export default __webpack_public_path__ + "announcement-blob-2.svg";